export const getSelectedFilterCount = (formatFilter: any, genderFilters: any, inclusionsFilters: any, daysFilters: any) => {
  const formatCount = formatFilter ? formatFilter.length : 0;
  const genderCount = genderFilters ? genderFilters.length : 0;
  const inclusionCount = inclusionsFilters ? inclusionsFilters.length : 0;
  const daysCount = daysFilters ? daysFilters.length : 0;
  const totalSelectedFilters = formatCount + genderCount + inclusionCount + daysCount;

  return totalSelectedFilters;
}
